import { Box } from '@mui/material';

import styles from './index.module.css';

interface Props {
  environmentName: string;
}

const EnvironmentLabel: React.FC<Props> = ({ environmentName }) => {
  let environmentLabelStyle = styles.devEnvironment;
  switch (environmentName.toUpperCase()) {
    case 'PROD':
      environmentLabelStyle = styles.prodEnvironment;
      break;
    case 'INTEGRATION':
      environmentLabelStyle = styles.intEnvironment;
      break;
    case 'STAGE':
      environmentLabelStyle = styles.stageEnvironment;
      break;
    case 'TEST':
      environmentLabelStyle = styles.testEnvironment;
      break;
    case 'DEV':
    default:
      environmentLabelStyle = styles.devEnvironment;
      break;
  }

  const classNames = `${styles.EnvironmentLabel} ${environmentLabelStyle}`;

  return <Box className={classNames}>{environmentName}</Box>;
};

export default EnvironmentLabel;
